import Constants from '../Constants';
import { makeRequest } from '../Utilities/Common';

const { LOGIN_SUCCESS, LOGIN_FAIL, LOGIN_LOADING, LOGOUT, RESET_LOADING, RESET_SUCCESS, RESET_FAIL, REQUEST_RESET_FAIL, REQUEST_RESET_SUCCESS, REQUEST_RESET_LOADING } = Constants;

export const logout = () => ({ type: LOGOUT, payload: true });


export const login = (email, password) => async (dispatch) => {
  dispatch({ type: LOGIN_LOADING, payload: true });
  //remove login helper.
  const response = await makeRequest('','AUTH','POST', { email, password } );
    if (response.result) {
      dispatch({ type: LOGIN_SUCCESS, payload: response.data });
    }else{
      dispatch({ type: LOGIN_FAIL, payload: response.data });
    }
};

export const requestReset = ( email ) => async (dispatch) => {
  dispatch({ type: REQUEST_RESET_LOADING, payload: true });
  const response = await makeRequest('','REQUEST_RESET','PUT',{ email });
  if(response.result){
    dispatch({ type: REQUEST_RESET_SUCCESS, payload: true });
  }else{
    dispatch({ type: REQUEST_RESET_FAIL, payload: response.data });
  }
};

export const reset = ( email, password, password_reset ) => async (dispatch) => {
  dispatch({type: RESET_LOADING, payload: true });
  const response = await makeRequest('','RESET','PUT',{ email, password, password_reset });
  if(response.result) {
    dispatch({ type: RESET_SUCCESS, payload: true });
  }else{
    dispatch({ type: RESET_FAIL, payload: response.data });
  }
};


// WEBPACK FOOTER //
// ./src/Actions/AuthActions.js